import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-215d7e57"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "tip-box-cell",
  ref: "tipBoxCell"
}
const _hoisted_2 = { style: {"white-space":"wrap"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "...", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock("div", {
    class: "tip-box",
    ref: "tipBox",
    style: _normalizeStyle(`height: ${_ctx.height}px`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 512),
    ((_ctx.$refs?.tipBoxCell?.clientHeight || _ctx.clientHeight) > _ctx.height)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(`${_ctx.rotateIcon ? 'rotate' : ''} content-button`)
        }, [
          _createVNode(_component_el_popover, {
            placement: "top-start",
            title: _ctx.title,
            width: 400,
            trigger: _ctx.trigger
          }, {
            reference: _withCtx(() => [
              _hoisted_3
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _renderSlot(_ctx.$slots, "default", { style: "white-space: wrap;" }, undefined, true)
              ])
            ]),
            _: 3
          }, 8, ["title", "trigger"])
        ], 2))
      : _createCommentVNode("", true)
  ], 4))
}